export default function (): boolean {
  return process.env.JEST_WORKER_ID !== undefined;
}
